import React, { useEffect, useState } from "react";
import MenuBar from "./MenuBar";
import "../Styles/Business.css";
import { getData } from "../utils/store-data";
import { USER_ID } from "../utils/store-data-constants";
import { get_agent } from "../api/serverWrapper";
import Logo from "../assests/images/profile.png";
import { useMasterData } from "../context/MasterDataContext";
import EditBusiness_set_up from "./EditBusiness_set_up";
import { isEditable } from "@testing-library/user-event/dist/utils";

export default function Business() {
  const {
    religionMasterData,
    allCasteMasterData,
    communityMasterData,
    languageMasterData,
  } = useMasterData();
  const [partner, setPartner] = useState(null);
  const [showEditPage, setShowEditPage] = useState(false);

  const defaultPromotionalImages = [
    require("../assests/images/promotional_defalt_icon1.png"),
    require("../assests/images/promotional_defalt_icon2.png"),
    require("../assests/images/promotional_defalt_icon3.png"),
  ];

  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      const id = await getData(USER_ID);

      const agent_resp = await get_agent(id);

      console.log("Agent Data:", agent_resp.data);

      setPartner(agent_resp.data);
    } catch (error) {
      console.log(error);
    }
  };

  const religionOptions =
    religionMasterData?.map((item) => ({
      value: item.ReligionId,
      label: item.ReligionName,
    })) || [];

  const casteOptions =
    allCasteMasterData?.map((item) => ({
      value: item.CasteL2Id,
      label: item.CasteName,
    })) || [];

  const communityOptions =
    communityMasterData?.map((item) => ({
      value: item.CommunitiesId,
      label: item.CommunitiesName,
    })) || [];

  const languages = languageMasterData || [];

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        backgroundColor: "#FFF4E7",
        minHeight: "100vh",
      }}
    >
      <MenuBar />

      {partner ? (
        <div
          className={
            showEditPage
              ? " review-main-card-full mx-4 business-card"
              : " review-main-card mx-4 business-card"
          }
        >
          {/* PROFILE */}

          <div className="business-top-card">
            <div className="business-agent-info">
              <img
                src={partner?.User?.ProfilePhotoUrl || Logo}
                alt=""
                className="agent-profile-img"
              />

              <div>
                <h5>
                  {partner?.User?.FirstName} {partner?.User?.LastName}
                </h5>
                <span>Agent No {partner?.AgentId || "56123"}</span>
              </div>
            </div>

            <div className="business-tabs">
              <div className="d-flex align-items-center business-tab active justify-content-center gap-3">
                <img
                  src={require("../assests/images/my-business-icon.png")}
                  className="business-tabs-icon"
                  alt="My Business"
                />

                <div>My Business</div>
              </div>
            </div>
          </div>

          {showEditPage ? (
            <div className="business-edit-wrapper">
              <EditBusiness_set_up
                existingAgent={partner}
                onClose={() => {
                  setShowEditPage(false);
                  loadInitialData();
                }}
              />
            </div>
          ) : (
            <>
              <div className="review-profile-card mt-4">
                <div className="d-flex align-items-center justify-content-end me-4">
                  <img
                    src={require("../assests/images/edit_business_icon.png")}
                    alt=""
                    className="edit-business-icon"
                    onClick={() => setShowEditPage(true)}
                  />
                </div>

                <div className="d-flex align-items-center justify-content-center gap-3">
                  <img
                    src={partner?.BusinessLogo || Logo}
                    alt=""
                    className="review-logo-circle"
                  />

                  <h1>{partner?.BusinessName}</h1>
                </div>

                <p className="review-tagline">For your forever</p>

                <div className="review-stars">★ ★ ★ ★ ☆</div>

                <div className="review-top-info">
                  <div className="d-flex align-items-center gap-2">
                    <img
                      src={require("../assests/images/business_location_icon.png")}
                      alt="Location"
                      className="review-info-icon"
                    />
                    <span>{partner?.BusinessAddress}</span>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <img
                      src={require("../assests/images/business_expiriance_icon.png")}
                      alt="Experience"
                      className="review-info-icon"
                    />
                    <span>
                      {partner?.BusinessExperience || 0} Years Experience
                    </span>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <img
                      src={require("../assests/images/lang-icon.png")}
                      alt="Languages"
                      className="review-info-icon"
                    />
                    {/* <span>{partner?.LanguagesServe?.join(", ")}</span> */}

                    {partner?.LanguagesServe?.includes("all")
                      ? " All Languages"
                      : languages
                          ?.filter((item) =>
                            partner?.LanguagesServe?.includes(item.LangId),
                          )
                          ?.slice(0, 2)
                          ?.map((item) => item.LangDesc)
                          ?.join(", ")}
                  </div>
                </div>
              </div>

              {/* ABOUT */}

              <div className="review-about-section">
                <h3>About</h3>

                <p>{partner?.BusinessDescription}</p>
              </div>

              {/* IMAGES */}

              {/* <div className="agent-gallery-images">
                {partner?.PromotionalImages?.map((img, index) => (
                  <img key={index} src={img} alt="" />
                ))}
              </div> */}

              <div className="agent-gallery-images">
                {(partner?.PromotionalImages?.length > 0
                  ? partner.PromotionalImages
                  : defaultPromotionalImages
                ).map((img, index) => (
                  <img key={index} src={img} alt="" />
                ))}
              </div>

              <div className="review-detail-grid">
                {/* SERVICE DETAILS */}

                <div className="review-detail-card">
                  <h3>Service Details</h3>

                  <div className="review-section">
                    <p className="review-label">Religions</p>

                    <div className="review-pill-row">
                      {partner?.ReligionsServe?.includes("all") ? (
                        <div className="review-pill">All Religions</div>
                      ) : (
                        religionOptions
                          ?.filter((o) =>
                            partner?.ReligionsServe?.includes(o.value),
                          )
                          ?.map((item, index) => (
                            <div className="review-pill" key={index}>
                              {item.label}
                            </div>
                          ))
                      )}
                    </div>
                  </div>

                  <div className="review-section">
                    <p className="review-label">Castes</p>

                    <div className="review-pill-row">
                      {partner?.CastesServe?.includes("all") ? (
                        <div className="review-pill">All Castes</div>
                      ) : (
                        casteOptions
                          ?.filter((o) =>
                            partner?.CastesServe?.includes(o.value),
                          )
                          ?.map((item, index) => (
                            <div className="review-pill" key={index}>
                              {item.label}
                            </div>
                          ))
                      )}
                    </div>
                  </div>

                  <div className="review-section">
                    <p className="review-label">Communities</p>

                    <div className="review-pill-row">
                      {partner?.CommunitesServe?.includes("all") ? (
                        <div className="review-pill">All Communities</div>
                      ) : (
                        communityOptions
                          ?.filter((o) =>
                            partner?.CommunitesServe?.includes(o.value),
                          )
                          ?.map((item, index) => (
                            <div className="review-pill" key={index}>
                              {item.label}
                            </div>
                          ))
                      )}
                    </div>
                  </div>

                  <div className="review-section">
                    <p className="review-label">Languages</p>

                    <div className="review-pill-row">
                      {partner?.LanguagesServe?.includes("all") ? (
                        <div className="review-pill">All Languages</div>
                      ) : (
                        languages
                          ?.filter((o) =>
                            partner?.LanguagesServe?.includes(o.LangId),
                          )
                          ?.map((item, index) => (
                            <div className="review-pill" key={index}>
                              {item.LangDesc}
                            </div>
                          ))
                      )}
                    </div>
                  </div>
                </div>

                {/* AGENCY DETAILS */}

                <div className="review-detail-card">
                  <h3>Agency Details</h3>

                  <div className="review-price-section">
                    <p className="review-label">Contact Number</p>
                    <h4>{partner?.User?.PhoneNumber}</h4>
                  </div>

                  <div className="review-price-section">
                    <p className="review-label">Email Address</p>
                    <h4>{partner?.User?.EMail}</h4>
                  </div>

                  <div className="review-price-section">
                    <p className="review-label">Business Address</p>
                    <h4>{partner?.BusinessAddress}</h4>
                  </div>
                </div>
              </div>

              {/* CONTACT */}

              <div className="review-contact-section">
                <h3>Contact Agency</h3>

                <div className="review-contact-grid">
                  <div>
                    <img
                      className="review-contact-icon"
                      src={require("../assests/images/contect-info.png")}
                      alt=""
                    />
                    {partner?.User?.PhoneNumber}
                  </div>

                  <div>
                    <img
                      className="review-contact-icon"
                      src={require("../assests/images/email-icon.png")}
                      alt=""
                    />
                    {partner?.User?.EMail}
                  </div>
                </div>

                <div className="review-contact-address">
                  <img
                    className="review-contact-icon"
                    src={require("../assests/images/address-icon.png")}
                    alt=""
                  />

                  <div className="review-address">
                    {partner?.BusinessAddress}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      ) : (
        <div
          className="d-flex justify-content-center align-items-center vh-100"
          style={{ backgroundColor: "#FFF4E7" }}
        >
          Loading...
        </div>
      )}
    </div>
  );
}
